module.exports = __webpack_public_path__ + "static/media/08_andinvainthedreamer.b54aafeb.jpg";